import React, { useEffect, useRef } from 'react';
import ReturnPolicy from '../components/returns/ReturnPolicy';
import ReturnProcess from '../components/returns/ReturnProcess';
import { fadeIn } from '../utils/gsapAnimations';

function Returns() {
  const pageRef = useRef(null);

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  return (
    <div ref={pageRef} className="bg-cream">
      <div className="max-w-7xl mx-auto py-12 px-4">
        <h1 className="text-3xl font-lora font-semibold text-burgundy mb-6">Returns & Exchanges</h1>
        <ReturnPolicy />
        {/* <ReturnProcess /> */}
      </div>
    </div>
  );
}

export default Returns;